import submoduleBreadcrumbs from 'Modules/contacard/faq/subModuleBreadcrumbs';
import { buildCrudRoutes } from 'Arch/components/crud/CrudRouter';

const featureBreadcrumb = [
  ...submoduleBreadcrumbs,
  {
    text: 'FAQ - Categorias',
    disabled: true,
  },
];

export default [
  ...buildCrudRoutes({
    basePath: 'categories',
    baseName: 'contacard.faq.categories',
    moduleActive: 'contacard',
    subModuleActive: 'faq',
    baseBreadcrumbs: featureBreadcrumb,
    card: {
      title: 'FAQ - Categorias',
      icon: 'comment-bookmark',
    },
    listRoute: {
      filterComponent: () => true,
      btnText: 'Adicionar categoria',
      navigateBackRoute: 'contacard.submodules.list',
      newRouteName: 'contacard.faq.categories.new',
      pageTitle: 'FAQ - Categorias',
      pageContent: () => import('Modules/contacard/faq/categories/CategoriesCrudList.vue'),
      searchOptions: { label: 'Buscar categorias', searchAttribute: 'search' },
      searchComponent: () => import('Arch/components/crud/components/OnlySearchFilter.vue'),
    },
    newRoute: {
      component: () => import('App/modules/contacard/faq/categories/CategoriesForm.vue'),
      breadcrumbs: [
        {
          text: 'Adicionar categoria',
          disabled: true,
        },
      ],
    },
    editRoute: {
      component: () => import('App/modules/contacard/faq/categories/CategoriesForm.vue'),
      breadcrumbs: [
        {
          text: 'Editar categoria',
          disabled: true,
        },
      ],
    },
  }),
];
